
export default {
  '404':
      'Sorry! The page you are accessing does not exist or has insufficient permissions',
  el: {
    colorpicker: { confirm: 'OK', clear: 'Clear' },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: { emptyText: 'No Data' },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'],
      filterPlaceholder: 'Enter keyword',
      noCheckedFormat: '{total} items',
      hasCheckedFormat: '{checked}/{total} checked'
    },
    image: { error: 'FAILED' },
    pageHeader: { title: 'Back' },
    popconfirm: { confirmButtonText: 'Yes', cancelButtonText: 'No' },
    empty: { description: 'No Data' }
  },
  login: {
    user: 'Username',
    account: 'Account',
    password: 'Password',
    signin: 'Sign in',
    signtitle: 'User login',
    forgetpassword: 'Forgot password',
    regsiter: 'Developer register',
    accountLogin: 'Account Login',
    wechartLogin: 'WeChat Login',
    codeTips:
        'Check code SMS has been sent, valid for 30 minutes, please check in time.',
    phoneLogin: 'Phone Login',
    wetChatTips: 'Please use WeChat to scan the qr code to log in'
  },
  common: {
    retrieveAfterSeconds: 'seconds',
    getVerificationCode: 'Get  code',
    i18nKeyRequire: 'Please enter i18nKey',
    employeeNoTips: 'The job number supports the group of numbers and letters',
    uploadCompanyLogo: 'Support JPG, PNG upload avatar image format!',
    uploadCompanyLogoSize: 'Upload avatar image size can not exceed 2MB!',
    uploadAvaterTips:
        'Avatar supports JPG, PNG format, and the size does not exceed 2M',
    uploadSuccess: 'Uploaded successfully',
    uploadFail: 'Upload failed',
    i18nKey: 'i18nKey',
    sys: 'XiaMen ZKTeco CDP front-end framework',
    add: 'Add',
    search: 'Search',
    edit: 'Editor',
    release: 'Release',
    update: 'Update',
    delete: 'Delete',
    selectDate: 'Select date',
    select: 'Please select',
    cancel: 'Cancel',
    confirm: 'Confirm',
    success: 'Success',
    fail: 'Failed',
    remark: 'Remark',
    name: 'Name',
    status: 'Status',
    statusRequire: 'Please select the status',
    remarkRequire: 'Please enter the remark',
    nameRequire: 'Please enter the name',
    confirmDelete: 'Confirm delete?',
    successDelete: 'Successfully delete',
    cancelDelete: 'Deletion has been cancelled',
    addUser: 'Add user',
    addSuccess: 'Add success',
    inputUserName: 'Please enter the user name',
    sourceList: 'Source list',
    targetList: 'Target list',
    addUserSuccess: 'Add user successfully.',
    selectUser: 'Please select the user before you operate',
    confirmDeleteUserTip: 'Are you sure to delete the selected user?',
    startTime: 'Start time',
    startTimePla: 'Please enter the start time',
    endTime: 'End Time',
    endTimePla: 'Please enter the end time',
    userNamePla: 'Please enter the user name',
    logNamePla: 'Please enter the log name',
    logType: 'Log type',
    select1record: 'Please click the form to select the record!',
    confirmDeleteRecordTip: 'Are you sure to delete the selected record?',
    operation: 'Operation',
    errorNotice: 'Error',
    warningNotice: 'Warm prompt',
    timeSnyc: 'In the synchronous...',
    allSelect: 'Check all',
    deleteFail: 'Delete failed',
    versionInfo: 'Change log',
    signin: 'Login',
    languages: 'Language',
    zh_cn: 'Chinese',
    en: 'English',
    logout: 'Logout',
    console: 'Console',
    platform: 'Smart DBS',
    userLogin: 'User login',
    action: 'Operation',
    requestError: 'Request error',
    requestServiceError: 'Request service error',
    importedDate: 'Imported time',
    extModifiedDate: 'Third party modified time',
    lastUpdateTimeStamp: 'Last modified time',
    createdDate: 'Created time',
    createdBy: 'Created by',
    modifiedDate: 'Modified time',
    modifiedBy: 'Modified by',
    enterValue: 'Please enter content',
    searchValue: 'Search',
    type: 'Type',
    Label: 'Remark',
    Enabled: 'Enable',
    selectRecod: 'Please select data',
    notice: 'Notice',
    save: 'Save',
    cancelOperation: 'Cancel operation',
    refresh: 'Refresh',
    saveSucess: 'Save successfully!',
    lastupdateTime: 'Last modified time',
    statisticalInfo: 'Statistical information',
    yes: 'Confirm',
    not: 'Cancel',
    active: 'Active',
    unActive: 'Unactive',
    tip: 'Tip',
    details: 'Details',
    download: 'Export all devices',
    loginLoading: 'Loading, please be patient',
    apiDoc: 'Document',
    sessionTimeOut:
        'The session timeout and the page will jump to the login page',
    send: 'Send',
    sunday: 'Sun.',
    monday: 'Mon.',
    tuesday: 'Tues.',
    wednesday: 'Wed.',
    thursday: 'Thur.',
    friday: 'Fri.',
    saturday: 'Sat.',
    updateSuccess: 'Update success',
    loading: 'loading',
    noData: 'No data',
    reset: 'reset',
    inputKeyWord: 'Please enter a keyword',
    copyRightInfo: 'Copyright © 2021 ZKTECO CO.',
    noPhoto: 'Photo does not exist',
    isNoEmpty: 'Please enter a value',
    emailValid: 'Please enter the correct email format',
    httpValid: 'Please enter the correct url format',
    phoneValid: 'Please enter the correct phone format',
    maxPhoneLen: 'The maximum length of 11',
    stringInRange: 'The string length must be between {start} and {end}',
    validatorInputLength: 'Please enter less than {len} characters',
    alreadyBindEmail: 'The email has been bound',
    alreadyBindPhone: 'The phone number has been bound',
    chooseOptions: 'Please select',
    emailCodes: 'Please fill in the email verification code you received'
  },
  user: {
    confirmDelete: 'Confirm Delete?',
    accountByLogin: 'Login account',
    dbsPrivacy: '《Smart DBS Privacy Policy》',
    agree: 'I agree',
    useEmailReg: 'Use email to register',
    usePhoneReg: 'Use  phone to register',
    pwdStrength: 'Password strength',
    week: 'Week',
    middle: 'Middle',
    hight: 'Hight',
    noConfirmedPwd: 'Make sure the password cannot be empty',
    emailCodeError:
        'The email verification code entered is incorrect, please try again',
    sureEmailTip: 'Please enter the correct email address',
    onceLogin: 'Login immediately',
    baseInfo: 'Basic',
    activation: 'Get code',
    userNameTips:
        'Please fill in the user name not registered by entropy-based technology equipment platform',
    emailTips:
        'Please fill in the email address not registered by  device data bridge platform',
    emailCode: 'Email code',
    inputEmailCode: 'Please enter the email verification code',
    emailCodeTips:
        'Click to get the verification code and you will receive the verification email. Please backfill the 6-bit verification code in the email',
    inputPwdTips:
        'The password must contain numbers and letters and be between 8 and 16 digits long',
    services: 'Third party developer service agreement',
    regsiter: 'Register',
    hasAcount: 'Existing developer account?',
    startTime: 'Register start time',
    endTime: 'Register end time',
    superAdmin: 'Super admin',
    account: 'Account',
    status: 'Status',
    userName: 'User name',
    password: 'Password',
    confirmedPwd: 'Confirmed password',
    email: 'Email',
    phone: 'Phone',
    sex: 'Sex',
    nickName: 'Nickname',
    department: 'Department',
    role: 'Role',
    roleManagement: 'Role management',
    registerTime: 'Register time',
    inputAccount: 'Please enter account/phone/email',
    inputForgetName: 'Please enter account',
    inputName: 'Please enter name',
    inputPwd: 'Please set the password',
    inputPwd2: 'Please enter the password',
    input2ndPwd: 'Please enter the password again',
    pwdInconsistent: 'The password entered for the two times is inconsistent.',
    inputEmail: 'Please enter email',
    inputPhone: 'Please enter phone',
    inputNickName: 'Please enter nickname',
    selectStatus: 'Please select status',
    addUser: 'Add user',
    modifyUser: 'Update user',
    userDetail: 'User detail',
    select1record: 'Please click on the form to select a record',
    notAllowToChange: 'Super administrator not allowed to change!',
    notAllowToRemove: 'Super administrator is not allowed to delete!',
    notAllowToResetPwd: 'Reset super administrator password is not allowed!',
    notAllowToFreeze: 'Super administrator is not allowed to freeze',
    confirmDeleteTip:
        'Are you sure you want to delete a user which account is | ?',
    confirmResetPwd: 'Reset Password',
    confirmResetPwdTip:
        "Are you sure you want to will account for:  |  's password reset to 12345678?",
    successResetPwd: 'Reset password successfully',
    cancelResetPwd: 'Reset password has been cancelled',
    confirmFreeze: 'Freeze user',
    deleteUser: 'Delete user',
    confirmFreezeTip:
        'Are you sure you want to freeze the user which account is |?',
    successFreeze: 'Freeze user successfully',
    cancelFreeze: 'Freeze User has been cancelled',
    notNeedUnfreeze: 'The current user is enabled that no need to unfreeze',
    confirmUnfreeze: 'Unfreeze user',
    confirmUnfreezeTip:
        'Are you sure you want to unfreeze the user which account is |?',
    successUnfreeze: 'Unfreeze user successfully',
    cancelUnfreeze: 'Unfreeze User has been cancelled',
    roleAllot: 'Allot role',
    expirationDate: 'Expiration Date',
    findPwdByPhone: 'Use your phone to retrieve',
    findPwdByEmail: 'Use your email to retrieve',
    resetPwdSuc: 'Password reset successful',
    goBackStep: 'Previous ',
    welcomeReg: 'Welcome to register',
    registerSuccess:
        'Registration successful! Jump to the login page immediately',
    sendCodeSuccess: 'Verification code sent successfully!',
    recoverPassword: 'Retrieve Password',
    userNameNotEmpty: 'The username cannot be empty',
    passwordNotEmpty: 'The password cannot be empty',
    next: 'Next',
    code: 'Verification code',
    requireCode: 'Please enter the verification code',
    codeNotEmpty: 'The verification code cannot be empty',
    codeError: 'The verification code error',
    goSign: 'Jump to the login page',
    add: 'New employees',
    delete: 'Deleted employees'
  },
  department: {
    nameRequire: 'Please enter the department name',
    addDept: 'Add department',
    updateDept: 'Update department',
    parentDept: 'Parent',
    deptName: 'Name',
    deptStatus: 'Status',
    notDeleteRoot: 'Root department is not allowed to delete!',
    notDeleteDept: 'This department contains sub-departments, cannot delete!',
    confirmDeleteDeptTip: 'Are you sure to delete this department?',
    selectDept: 'Please select the department before you operate'
  },
  integrators: { addIntegrators: 'Add Account', confirmFreeze: 'Freeze Users' },
  area: {
    nameRequire: 'Please enter the area name',
    addArea: 'Add area',
    updateArea: 'Update area',
    parentArea: 'Parent',
    areaName: 'Name',
    areaStatus: 'Status',
    notDeleteRoot: 'Root area is not allowed to delete!',
    notDeleteArea: 'This area contains sub-areas, cannot delete!',
    confirmDeleteAreaTip: 'Are you sure to delete this area?',
    selectArea: 'Please select the area before you operate.'
  },
  resource: {
    resourceName: 'Resource name',
    sortNo: 'Sort',
    resourceEvent: 'Button event',
    resourceType: 'Type',
    notDeleteRoot: 'Root resource are not allowed to be deleted!',
    notUpdateRoot: 'Root resource are not allowed to be modified!',
    addResource: 'Add resource',
    updateResource: 'Update resource',
    confirmDeleteTip: 'Are you sure you want to delete the resource: ',
    icon: 'Icon',
    routerName: 'Routing name',
    btnGroup: 'Group name',
    urlRequire: 'Please enter the url',
    routerNameRule: 'The same name as the development configuration routing',
    btnGroupRequire: 'Please enter the name of the button group',
    btnTypeRequire: 'Please select the button type',
    btnStyleRequire: 'Please select the button style',
    btnType: 'Button type',
    btnStyle: 'Button style',
    btnEffect: 'Button effect',
    parentResource: 'Parent',
    default: 'Default',
    primary: 'Primary',
    success: 'Success',
    text: 'Text',
    info: 'Information',
    warning: 'Warning',
    danger: 'Dangerous',
    plain: 'Plain',
    round: 'Round',
    circle: 'Circle',
    typeRequire: 'Please select the resource type',
    sortNoRequire: 'Please enter the serial number',
    intRequire: 'Please enter a positive integer',
    parentRequire: 'Please select the parent resource',
    parentRule1: 'Parent resource is not allowed to be resource itself',
    parentRule2:
        'Parent resource is not allowed to be children of this resource',
    resourceEventRequire: 'Please enter the button event',
    disabled: 'Disabled'
  },
  role: {
    addRole: 'Add role',
    addRoleGroup: 'Add role group',
    role: 'Role',
    addRoleSuccess: 'Add role success',
    updateRoleSuccess: 'Update role success',
    roleGroup: 'Role group',
    roleName: 'Role name',
    roleGroupName: 'Role group name',
    roleGroupNameRequire: 'Please enter the role group name',
    roleGroupRequire: 'Select the role group',
    roleNameRequire: 'Please enter the role name',
    noGroup: 'No group',
    confirmDeleteTip: 'Are you sure you want to delete this user role?',
    confirmDeleteGroupTip:
        'Are you sure you want to delete this user role group?',
    addUser: 'Add user',
    authorization: 'Authorization',
    authorizeSuccess: 'Authorization success',
    authorizeFail: 'Authorization failure',
    selectRoleToAddUserTip:
        'Select the role you want to add users to on the left.',
    selectRoleToAuthorizeTip:
        'Please select the role you want to authorize on the left.',
    selectUser: 'Please select the user',
    confirmDeleteUserTip: "Are you sure you want to remove： |'s user role?",
    notDeleteAdmin:
        'The admin user under the super administrator is not allowed to delete!'
  },
  param: {
    paramType: 'Parameter type',
    paramName: 'Parameter name',
    paramValue: 'Parameter value',
    sortNo: 'Order value',
    paramStatus: 'Parameter status',
    addParam: 'Add parameter',
    updateParam: 'Update parameter',
    confirmDeleteTip: 'Are you sure to delete this parameter?',
    typeRequire: 'Please enter the parameter type',
    nameRequire: 'Please enter the parameter name',
    valueRequire: 'Please enter the parameter value'
  },
  dictionary: {
    name: 'Name',
    type: 'Type',
    dictName: 'Name',
    dictType: 'Type',
    value: 'Value',
    sortNo: 'Order value',
    addDict: 'Add dictionary',
    updateDict: 'Update dictionary',
    confirmDeleteTip: 'Are you sure to delete this dictionary?',
    nameRequire: 'Please enter the dictionary name.',
    typeRequire: 'Please enter the dictionary type.',
    valueRequire: 'Please enter the dictionary value.',
    sortNoRequire: 'Please enter the order value.'
  },
  announcement: {
    id: 'Id',
    title: 'Title',
    content: 'Content',
    validDate: 'Valid date',
    modifiedDate: 'Modified date',
    modifiedBy: 'Modified by',
    createdDate: 'Release time',
    createdBy: 'Created by',
    addDict: 'Add announcement',
    updateDict: 'Update announcement',
    beginTime: 'Begin',
    endTime: 'End',
    effectTime: 'Begin',
    expirationTime: 'End',
    addAnnouncement: 'Add announcemnet',
    deleteSure: 'Are you sure you want to delete this notice?',
    modifyAnnouncemnet: 'Modify announcemnet',
    choiceTime: 'Choose time',
    announcementStatus: 'Whether issued',
    inputTitle: 'Please enter the title',
    inputContent: 'Please enter the content',
    inputTime: 'Please enter the time',
    titleMaxLength: 'The maximum length is 50',
    contentMaxLength: 'The maximum length is 500',
    nameMaxLength: 'The maximum length is 30',
    announcementDetal: 'Announcement detail',
    status: 'Status',
    annRelease: 'Published',
    annNotRelease: 'Not release',
    releaseSuccess: 'Release success',
    releaseFail: 'Post failure'
  },
  advice: {
    id: 'Id',
    advice: 'Advice',
    reply: 'Reply',
    replyBy: 'Reply by',
    replyDate: 'Reply time',
    status: 'Status',
    createdDate: 'Create time',
    createdBy: 'Created by',
    createTime: 'Create time',
    beginTime: 'Begin time',
    endTime: 'End time',
    replayStatus: 'Replay status',
    replied: 'Replied',
    noReply: 'No reply',
    all: 'All',
    replayBtn: 'Replay',
    deleteBtn: 'Delete',
    addAdvice: 'Feedback',
    adviceContent: 'Content',
    adviceReplay: 'Advice replay',
    advContent: 'Advice',
    replayContent: 'Replay',
    deleteSure: 'Are you sure to delete this recommendation?'
  },
  loginLog: {
    loginLog: 'Login log',
    loginFailLog: 'Login failure log',
    exitLog: 'Exit log',
    account: 'Account',
    time: 'Time',
    details: 'Details',
    source: 'Source'
  },
  operatorLog: {
    logName: 'Log name',
    operatorLog: 'Operation log',
    exceptionLog: 'Exception log',
    account: 'Account',
    className: 'Operation class',
    methodName: 'Method',
    msg: 'Message',
    result: 'Result',
    costTime: 'Time-consuming(ms)',
    time: 'Time'
  },
  account: {
    accountInfo: 'Account information',
    modifyPwd: 'Modify password',
    loginOut: 'Logged out',
    account: 'Account',
    oldPwd: 'Old password',
    newPwd: 'New password',
    confirmNewPwd: 'Confirm password',
    oldPwdRequire: 'Please enter the old password',
    newPwdRequire: 'Please enter the new password',
    confirmNewPwdRequire: 'Please enter the new password again',
    newEqualOld: 'The new password is the same as the old one',
    newNotEqualNew: 'The two password entries are different',
    modifyPwdSuccess: 'Modify password successfully',
    newPasswordLength: 'The length must be between 8 and 16 bits',
    mustContain: 'Must contain numbers and letters'
  },
  dstConfig: {
    colHeaderTip: 'If the ending year is N/A, it is permanent',
    dstName: 'DST name',
    timezone: 'timeZone',
    startTime: 'startTime',
    endTime: 'endTime',
    startYear: 'startYear',
    endYear: 'endYear',
    dstNameRequire: 'Please enter the DST name',
    timezoneRequire: 'Please enter the timezone',
    startTimeRequire: 'Please enter the startTime',
    endTimeRequire: 'Please enter the endTime',
    startYearRequire: 'Please enter the startYear',
    endYearRequire: 'Please enter the endYear',
    active: 'active',
    addDstConfig: 'add DST config',
    updateDstConfig: 'update DST config',
    confirmDeleteTip: 'Are you sure delete this daylight saving time rule?',
    startTimeDesc:
        'The format is: MMIIWWHH, MM: month, II: the first few weeks (01: indicates the first week, 02: indicates the second week, 03: indicates the third week, 04: indicates the fourth week, 11: Means the first week to the end), WW: week, HH: hour',
    endTimeDesc: 'If it is empty, it is permanently valid'
  },
  enterprise: {
    orgType: 'Organization type',
    orgList: 'Organization',
    org: 'Organization',
    orgDetail: 'Details',
    deviceAssignment: 'Device assignment',
    organizationTypeId: 'Organization type',
    orgCode: 'Department code',
    orgName: 'Department name',
    orgManager: 'Department manager',
    parentOrganizationCode: 'Superior department code',
    parentOrganizationName: 'Superior department name',
    userManagement: 'Administrators'
  },
  enterprisedashboard: {
    clockStatus: 'Device status ',
    employeeUpdate: 'Employee status '
  },
  alcoholDetectionRecord: {
    pin: 'Person ID',
    name: 'Person name',
    dataFromDevice: 'Data From Device',
    date: 'Attendance Date',
    alcoholDegree: 'Alcohol Degree',
    drivingLicense: 'Driving License',
    healthStatus: 'Healthy Status',
    sleepHours: 'Sleep Hours',
    licesnePlateNo: 'Licesne PlateNo',
    bodyTemparature: 'Body Temparature',
    confirm: 'Confirm',
    comment: 'Comment'
  },
  employee: {
    employeeList: 'Employee list',
    employeeDetail: 'Employee information details',
    employeeNo: 'Employee no',
    reqEmployeeNo: 'Please enter your job number',
    lastName: 'First Name',
    reqLastName: 'Please enter the first name',
    firstName: 'Last Name',
    reqFirstName: 'Please enter the last name',
    formattedName: 'Name',
    photo: 'Photo',
    gender: 'Gender',
    email: 'Email',
    phone: 'Phone number',
    status: 'Status',
    active: 'Active',
    employeeBasicInfo: 'Basic',
    employeeAttInfo: 'Check',
    assignment: 'Device assignment',
    badgeNo: 'Card number',
    devicePassword: 'Password',
    verifyingMode: 'Verification',
    devicePermission: 'Permissions',
    hireDate: 'Hiredate',
    currentDept: 'The total number of the current department is {0}',
    totalUser: 'A total of {0}',
    addEmployee: 'Add employees',
    updateEmployee: 'Update employees',
    selectOrgTip:
        'Please select the organizational structure before adding people',
    deleteEmployee:
        'Are you sure you want to delete the employee? Do you want to continue?',
    downloadTemplate: 'Download template',
    importEmployee: 'Import employees',
    exportEmployee: 'Export employees',
    drivingStart: 'Driving License Start',
    drivingEnd: 'Driving License End',
    enteredFingerprint: 'Fingerprint entered',
    notEnteredFingerprint: 'Fingerprint not entered',
    enteredVisibleLight: 'Visible light not entered',
    enteredNirFace: 'NIR entered',
    notEnteredNirFace: 'Near infrared not entered',
    enteredPalmPrint: 'Palmprint has been entered',
    notEnteredPalmPrint: 'Not entered outside palmprint'
  },
  licensePlate: {
    num: 'License Plate No',
    alias: 'License Plate Alias',
    employeeNo: 'LicensePlate no',
    reqLicensePlateNo: 'Please enter your job number',
    lastName: 'First Name',
    reqLastName: 'Please enter a last name',
    firstName: 'Last Name',
    reqFirstName: 'Please enter the first name',
    formattedName: 'Name',
    photo: 'Photo',
    gender: 'Gender',
    email: 'Email',
    phone: 'Phone number',
    status: 'Status',
    active: 'Active',
    employeeBasicInfo: 'Basic',
    employeeAttInfo: 'Check',
    assignment: 'Device assignment',
    badgeNo: 'Card number',
    devicePassword: 'Password',
    verifyingMode: 'Verification',
    devicePermission: 'Permissions',
    hireDate: 'Hiredate',
    currentDept: 'The total number of the current department is {0}',
    totalUser: 'A total of {0}',
    addLicensePlate: 'Add License Plates',
    updateLicensePlate: 'Update License Plates',
    selectOrgTip:
        'Please select the organizational structure before adding people',
    deleteLicensePlate:
        'Are you sure you want to delete the licensePlate? Do you want to continue?',
    checkImportOrganization:
        'Are you sure you want to import license plates here?',
    downloadTemplate: 'Download template',
    importLicensePlate: 'Import License Plates',
    exportLicensePlate: 'Export License Plates'
  },
  devicePermission: {
    '0': 'Normal user',
    '7': 'Site administrator',
    '14': 'Device administrator'
  },
  findpassword: {
    verifyAccount: 'Account verification',
    verifyCode: 'Verification code check',
    resetPassword: 'Reset password',
    success: 'Reset successfully'
  },
  attendanceCode: {
    laborCodes: 'Attendance work code',
    laborCodesType: 'Attendance work code',
    laborCodeDeatils: 'Attendance work code details',
    newOrgCode: 'Add',
    requireLaborCodes: 'Please enter the attendance work code',
    requireLaborCodesName: 'Please enter the attendance work code name',
    requirelaborCodesType: 'Please enter the attendance work code type',
    requireLaborCodesTypeName:
        'Please enter the attendance work code type name',
    attendanceCodeList: 'Code list',
    code: 'Attendance work code',
    assignment: 'Device assignment',
    unBindWordCode: 'Are you sure to unbind?'
  },
  devicesCommand: {
    comId: 'ID',
    sn: 'SN',
    imme: 'Whether the emergency',
    protocol: 'Protocol',
    content: 'Content',
    committime: 'Date',
    returnTime: 'Return time',
    status: 'status',
    returnValue: 'Return value',
    status0: 'Did not taken away',
    code: 'Code',
    status1: 'It has been taken away without reply',
    status2: 'Replied',
    status3: 'Cleared',
    result: 'Result',
    success: 'Success',
    fail: 'Fail',
    commandResult: 'Result',
    all: 'All',
    ratchResend: 'Batch resend',
    sendCommandsTip:
        'A total of {length} commands are selected. Do you want to resend the selected commands?',
    sendCommandTip: 'Do you want to resend the command?'
  },
  contry: {
    AD: 'Andorra',
    AE: 'United Arab Emirates',
    AF: 'Afghanistan',
    AG: 'Antigua and Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AO: 'Angola',
    AR: 'Argentina',
    AT: 'Austria',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BB: 'Barbados',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BF: 'Burkina Faso',
    BG: 'Bulgaria',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Palestine',
    BM: 'Bermuda',
    BN: 'Brunei',
    BO: 'Bolivia',
    BR: 'Brazil',
    BS: 'Bahamas',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Canada',
    CF: 'Central African Republic',
    CG: 'Congo',
    CH: 'Switzerland',
    CK: 'Cook Islands',
    CL: 'Chile',
    CM: 'Cameroon',
    CN: 'China',
    CO: 'Columbia',
    CR: 'Costa Rica',
    CS: 'Czech Republic',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DE: 'Germany',
    DJ: 'Djibouti',
    DK: 'Denmark',
    DO: 'Dominican Republic',
    DZ: 'Algeria',
    EC: 'Ecuador',
    EE: 'Estonia',
    EG: 'Egypt',
    ES: 'Spain',
    ET: 'Ethiopia',
    FI: 'Finland',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GB: 'England',
    GD: 'Grenada',
    GE: 'Georgia',
    GF: 'French Guiana',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GM: 'Gambia',
    GN: 'Guinea',
    GR: 'Greece',
    GT: 'Guatemala',
    GU: 'Guam',
    GY: 'Guyana',
    HK: 'HKSAR',
    HN: 'Honduras',
    HT: 'Haiti',
    HU: 'Hungary',
    ID: 'Indonesia',
    IE: 'Ireland',
    IL: 'Israel',
    IN: 'India',
    IQ: 'Iraq',
    IR: 'Iran',
    IS: 'Iceland',
    IT: 'Italy',
    JM: 'Jamaica',
    JO: 'Jordan',
    JP: 'Japan',
    KE: 'Kenya',
    KG: 'Kyrgyzstan',
    KH: 'Cambodia',
    KP: 'North Korea',
    KR: 'South Korea',
    KT: "Republic of Cote d'Ivire",
    KW: 'Kuwait',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Lebanon',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    LY: 'Libya',
    MA: 'Morocco',
    MC: 'Monaco',
    MD: 'Moldova',
    MG: 'Madagascar',
    ML: 'Mali',
    MM: 'Burma',
    MN: 'Mongolia',
    MO: 'Macao',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexico',
    MY: 'Malaysia',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NE: 'Niger',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Netherlands',
    NO: 'Norway',
    NP: 'Nepal',
    NR: 'Nauru',
    NZ: 'New Zealand',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'French Polynesia',
    PG: 'Papua New Guinea',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Poland',
    PR: 'Puerto Rico',
    PT: 'Portugal',
    PY: 'Paraguay',
    QA: 'Qatar',
    RO: 'Romania',
    RU: 'Russia',
    SA: 'Saudi Arabia',
    SB: 'Solomon Islands',
    SC: 'Seychelles',
    SD: 'Sudan',
    SE: 'Sweden',
    SG: 'Singapore',
    SI: 'Slovenia',
    SK: 'Slovakia',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    ST: 'Sao Tome and Principe',
    SV: 'Salvador',
    SY: 'Syria',
    SZ: 'Swaziland',
    TD: 'Chad',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TM: 'Turkmenistan',
    TN: 'Tunisia',
    TO: 'Tonga',
    TR: 'Turkey',
    TT: 'Trinidad and Tobago',
    TW: 'Taiwan Province',
    TZ: 'Tanzania',
    UA: 'Ukraine',
    UG: 'Uganda',
    US: 'America',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VC: 'Saint Vincent',
    VE: 'Venezuela',
    VN: 'Vietnam',
    YE: 'Yemen',
    YU: 'Yugoslavia',
    ZA: 'South Africa',
    ZM: 'Zambia',
    ZR: 'Zaire',
    ZW: 'Zimbabwe'
  },
  tenantDashboard: {
    tenants: 'Company information statistics',
    newEnrolled: 'New-added company',
    inactive: 'Inactive'
  },
  dashboard: {
    dataFormste: '{value} day',
    onlineDevice: 'Online devices',
    offLineDevice: 'OffLine devices',
    disableDevice: 'Disable devices',
    deviceTypetop10: 'Device type top10',
    addDeviceBar: 'New device line chart',
    areaDeviceTop10: 'Area device top10',
    globalDeviceDis: 'Global device distribution',
    addDevice: 'Add device',
    device: 'Device'
  },
  apiLog: {
    mid: 'Mid',
    companyUser: 'Integration account',
    requestMessage: 'Request message',
    responseMessage: 'Response Message',
    ip: 'IP',
    createDate: 'Request date',
    requestResult: 'Request result',
    result: 'Result',
    useTime: 'Delivery time',
    url: 'URL',
    apiLog: 'API Log',
    requestTime: 'Request Time',
    appKey: 'AppKey',
    success: 'success',
    fail: 'fail',
    apiName: 'Api Name',
    elapsedMs: 'Elapsed Time',
    requestContent: 'Request Content',
    statusCode: 'Status Code',
    copySucess: 'Copy succeeded',
    copyError:
        'Replication is not supported. This browser does not support automatic replication',
    copy: 'Copy',
    appCode: 'appCode',
    dbs: 'Smart  DBS',
    cc: 'control center',
    ufo: 'Firmware update',
    appName: 'app Name',
    method: 'method'
  },
  datapush: {
    appList: 'App list',
    dataList: 'Data list',
    pushLoad: 'Pushing data',
    message: 'Message content',
    lastPushTime: 'Last push time',
    num: 'Tried times',
    asyPushTip: 'Data is being pushed asynchronously',
    pushbtnTip: 'Apply asynchronous push of relay data',
    sid: 'Push event',
    mid: 'Mid',
    total: 'Total',
    success: 'Success',
    fail: 'Fail',
    pushURL: 'Push url',
    dataType: 'Data type',
    dataPeriod: 'Data keep period',
    lastPushStatus: 'Last push status'
  },
  goBack: 'Go back',
  goLoginPage: 'Login page',
  orgTree: {
    parentCode: 'Superior department code',
    parentCodeTip: 'Please enter the superior department code',
    parentName: 'Superior department name',
    parentNameTip: 'Please enter the name of the superior department',
    deptCode: 'Department code',
    deptCodeTip: 'Please enter the department code',
    deptName: 'Department name',
    deptNameTip: 'Please enter the department name',
    add: 'Add department',
    update: 'Update department',
    execute: 'Execution of...',
    createOrg: 'Organizational structure created successfully!',
    updateOrg: 'Organizational structure updated successfully!',
    ownerDept: 'Department'
  },
  header: {
    enterCompanyName: 'Please enter the company name',
    enterAppName: 'Please enter the application name',
    online: 'Online',
    offline: 'Offline',
    selectApp: 'Please select application',
    all: 'All',
    createApp: 'Add application ',
    selectCompany: 'Please select a company',
    createCompany: 'Add company',
    companyCode: 'Enterprise numbers',
    companyName: 'Enterprise name',
    reqName: 'Please enter the company name',
    reqNo: 'Please enter the company number'
  },
  configType: {
    pushType: 'Push type',
    name: 'Name',
    toPush: 'Push',
    turnOn: 'open',
    turnOff: 'close',
    desc: 'Description',
    operate: 'Operation',
    only: 'Unique identifier for the push message type',
    queue: 'Queue',
    sort: 'Sort',
    reqName: 'Please enter name',
    reqSid: 'Please enter the sid',
    maxLength: 'The maximum length is 50 words',
    reqQueue: 'Please select the queue',
    addConfig: 'Add configuration',
    updateConfig: 'Update configuration',
    deleteConfig:
        'Deleting this will close all app push messages of this type. Are you sure to delete'
  },
  developer: {
    randomNote:
        'A token is part of the key, and it will be used to generate digital sign digest.',
    randomNote16:
        'The key is used to encrypt the content in the data push request.',
    pushIntroduce: 'allow DBS pushing data to your linked system service.',
    employeNum: 'Number of employe',
    paramsCongig: 'Parameter configuration',
    immCreate: 'Add',
    noApp: "You don't have an app yet, add it!",
    companyNum: 'Enterprises',
    appNumber: 'App number',
    dicTypePla: 'Please enter a dictionary name type',
    dicNamePla: 'Please enter a dictionary name',
    enterApp: 'Enter',
    deleteApp: 'Delete',
    withdrawApp: 'Restore',
    withdrawTip: 'Are you sure you want to restore the application?',
    withdrawAppSuccess: 'Restore success',
    destroyApp: 'Permanently delete',
    destroyAppSuccess: 'Permanently delete success',
    destroySure:
        'After the application is permanently delete, the associated data will be directly deleted and not recoverable. Do you want to delete it?',
    WithdrawSure:
        'After the application is restore, it will return to the list of applications. Do you want to restore?',
    name: 'Name',
    dashboard: 'Dashboard',
    appDeatil: 'Details',
    pushSetting: 'Data push setting',
    dataTransferStation: 'Data push maintenance',
    apiLog: 'Api log',
    deviceTotle: 'All devices',
    offlineCount: 'Offline devices',
    onLineCount: 'Online devices ',
    relayNum: 'Transit station messages',
    selectDataType: 'Select data type',
    goAppList: 'Go back',
    cancel: 'Cancel',
    cancelWithdrawApp: 'Cancel the operation',
    goback: 'Go Back',
    selectType: 'Select Type',
    companyAdmin: 'Enterprise administrator',
    companySettingDes:
        'The platform authorizes developers to create and manage accounts of enterprises under the platform. This account can log into the platform and manage the operation of the enterprise, personnel and equipment. It is not enabled by default.',
    appFnSetting: 'Application Setting',
    pushDes: 'Description:',
    changeWay: 'Switching',
    appDes: 'Application description',
    newsSub: 'News subscription',
    dataTransfer: 'Data transfer',
    abnormalRemind: 'Abnormal remind',
    remindSet: 'Remind set',
    remindSet1: 'hours, message are stacked more than',
    remindSet2: 'item',
    apiReport: 'API report',
    receiveMail: 'Receive Mail',
    statisticsRemind: 'Statistics remind',
    statisticsReport: 'Statistics report',
    daily: 'Daily report',
    dailyTips: 'Daily data are the data of the previous day',
    week: 'Weekly report',
    weekTips:
        'The data of the weekly report is the data of the previous week, and it will be pushed every Monday',
    month: 'Monthly report',
    monthTips:
        'The monthly report data is the data of the previous month and will be pushed on the first day of each month',
    mailSetMax: 'The number of receiving mailboxes has reached its limit',
    appName: 'Application name',
    developerAccount: 'Developer Account',
    assApplication: 'Associated application',
    config: 'Config',
    newEmail: 'New email',
    changeEmail: 'Change email',
    isOk: 'Yes',
    createAppSucess: 'The application was created successfully !',
    visiable: 'visible',
    disvisible: 'invisible',
    updateApp: 'Update app',
    deleteTips:
        'After deleting the application, it will enter the recycle bin. If you want to clear the application data, please go to the recycle bin for destruction.',
    lastQuest: 'Last active time',
    aeskeyPla: 'Please enter the encryption key',
    tokenPla: 'Please enter the token',
    desPla: 'Please enter the application description',
    phonePla: 'Please enter your mobile phone number',
    contactPerPla: 'Please enter the contact person',
    appEmailPla: 'Please enter email address',
    appNamePla: 'Please enter the application name',
    appList: 'App list',
    appInfo: 'App info',
    details: 'Details',
    setting: 'Setting',
    addApp: 'Add app',
    deleApp: 'Delete app',
    id: 'ID',
    code: 'Code',
    des: 'Application contents',
    contactPerson: 'Contact',
    mail: 'E-mail',
    phone: 'Phone number',
    appKey: 'AppKey',
    appSecret: 'AppSecret',
    pushDerail: 'Push switch',
    url: 'URL',
    token: 'Token',
    aeskey: 'Encrypted secret key',
    aesStatus: 'Data encrypted',
    eventTypeArray: 'Push data category',
    serviceConfig: 'Data push configuration',
    requireName: 'Please enter application name',
    appNameLength: 'The maximum length is 16 characters',
    requireMail: 'Please enter email address',
    requireCode: 'Please enter verification code',
    randomCode: 'Create random access code',
    reset: 'Reset',
    saveTip: 'Saving',
    resetTip: 'Are you sure to reset appSecret?',
    pushPunchRecordFunOn: 'Attendance records',
    pushPhoto: 'Attendance photos',
    pushDeviceInitFunOn: 'Device init',
    pushRegisterFpTipFunOn: 'Fingerprint registration',
    pushDeviceStatusFunOn: 'Device status',
    validateUrl: 'Test connection',
    urlTip: 'Please enter a valid url',
    urlEg: 'For example: https://www.zkteco.com/',
    emainValidate: 'Please enter the correct email address'
  },
  doc: {
    apiDoc: 'API document',
    faq: 'FAQ',
    version: 'Version',
    operate: 'Operations handbook',
    tenant: 'Tenant documents',
    developer: 'Developer documents',
    enterpriseAdmin: 'Enterprise admin documents'
  },
  operationMsg: {
    uploadSuc: 'Uploaded successfully',
    updateSuc: 'Modify successfully',
    bindSuc: 'Binding success',
    addSuc: 'Successfully added',
    sendSuc: 'Send successfully',
    importSuc: 'Import success',
    deleteSuc: 'Successfully delete'
  },
  sysTemplate: {
    type: 'Type',
    title: 'Title',
    templateName: 'Name',
    content: 'Content',
    group: 'Group',
    languange: 'Language',
    satatus: 'Status',
    create: 'Creator',
    createData: 'Creation date',
    update: 'Modifier',
    updateData: 'Modification date',
    delteTemplate:
        'Are you sure to delete the template, do you want to continue?',
    editTemp: 'Template editor',
    viewTemp: 'Template preview',
    addTemp: 'Add template',
    tempTips1:
        'Template example: {1} is your login verification code, please fill in {2} minutes. If not operated by me, please ignore this message.',
    tempTips2:
        '(Where {number} is customizable and must be numbered consecutively from 0, such as {0}, {1}, etc.)',
    sign: 'Signature',
    inputCode: 'Please enter the template code',
    inputType: 'Please enter the template type',
    inputLang: 'Please enter the template language',
    inputName: 'Please enter the template name',
    inputTitle: 'Please enter the template title',
    inputContent: 'Please enter the template content',
    inputGroup: 'Please enter template grouping'
  },
  wxbind: {
    unbindWx: 'WeChat unbundling',
    unbindWxTips: 'You will unbind this account, do you want to continue?',
    bindPhoneSuc: 'Successful mobile phone binding'
  },
  center: {
    isGoOn: 'Continue',
    isNotBind:
        'You have not yet bound an email, please bind an email in your personal center first',
    disposeAccountTips:
        'This action will cancel your account. After logging out, you will not be able to log in again, SMARTDBS will also clear all the data related to the account. Please be careful.',
    deal: 'Privacy agreement',
    policy: 'Privacy Policy',
    clickShow: 'Click to view',
    disposeAccount: 'Close an account',
    verPhone: 'Please enter the correct cell phone number',
    weakPwd:
        'The password you used does not contain Numbers or letters, please reset!',
    centerpage: 'Personal center',
    basicInfo: 'Baisc infomation',
    socialAccount: 'Social account binding',
    noBindEmail: 'No mailbox is bound',
    noBindPhone: 'Unbound cell phone',
    valWay: 'Changing your phone/email address requires authentication',
    valEmail: 'Email  verification',
    valPhone: 'Phone verification',
    reGetCode: 'seconds',
    getCode: 'Get code',
    code: 'Code',
    plaCode: 'Please enter a verification code',
    plaPhone: 'Please enter your cell phone number',
    plaSureEmail: 'Please enter the correct email address',
    plaEmail: 'Please enter your email address',
    auth: 'Authentication',
    updateNicknameSuc: 'Nickname modification successful',
    plaContent: 'Please enter the content',
    updateWetchat: 'Modify weChat',
    nobindWetchat: 'Unbound, click',
    updatePassword: 'Change password',
    updatePhone: 'Modify  phone',
    bindPhone: 'Binding  phone',
    updateEamil: 'Modify email',
    bindEmail: 'Binding email',
    bindWetchat: 'Binding weChat',
    password: 'Password',
    phone: 'Phone',
    email: 'Email',
    headImg: 'Avatar',
    nickName: 'Nickname',
    account: 'Account',
    wetchat: 'WetChat',
    expirationDate: 'Expiration Date'
  },
  appSetting: { deviceCommand: 'Device command' },
  pushStation: { errorRecord: 'Exception record' },
  deviceEmp: {
    bindEmp: 'Personnel binding',
    deviceBindEmp: 'Devive personnel binding',
    orgTree: 'Organizational structure',
    empList: 'Personnel list',
    selectDevice: 'Please select device',
    unbindDevice: 'This operation unties the device. Do you want to continue?',
    unbindSuc: 'Device unbundled successfully',
    unbindCan: 'Unbinding has been cancelled',
    hasDevice: 'Please confirm the existence of the device'
  },
  empList: {
    lostImport: 'Bulk import',
    choiseFile: 'Select file',
    extName: 'Support for extensions',
    extTip: '.xlsx or .xls',
    finishImport: 'Batch import completed',
    beginImport: 'Start importing',
    finish: 'Finish',
    onlyXLSL: 'Only.xLSL file formats are supported'
  },
  attRecord: { temperature: 'Temperature', hasMask: 'Mask' },
  companyList: {
    selectApp: 'Please select App',
    deletCompany:
        'This action will permanently delete the company. Do you want to continue?'
  },
  annList: {
    sendEmail: 'Send email',
    dev: 'developer',
    ent: 'Enterprise admins ',
    sureRelase: 'Are you sure you want to publish this system announcement?'
  },
  com_log: {
    tipMsg:
        'The list includes support services for device communication activities in the past 30 days',
    nearlyDays7: 'Nearly 7 days',
    search: 'Search',
    eventTime: 'Event Time',
    protocol: 'protocol',
    sn: 'SN',
    type: 'Event type',
    mid: 'Message ID',
    funcName: 'Function Name',
    loadMore: 'Loading More',
    content: 'Content',
    associatedLog: 'Associated Log',
    result: 'Result',
    success: 'success',
    fail: 'fail',
    inputSn: 'Please enter SN',
    inputMid: 'Please enter Message ID',
    selectProtocol: 'Please Select Protocol',
    selectEventType: 'Please Select EventType',
    selectFuncName: 'Please Select Function Name',
    selectResult: 'Please Select  Result'
  },
  device: {
    com_log: 'Communication Log',
    uploadAtt: 'Upload attendance record',
    uploadUserInfo: 'Upload user data',
    synData: 'Sync user data to device',
    network: 'Network',
    deviceUser: 'Equipment usage',
    deviceCommand: 'Device command',
    deviceSelectPla: 'Please select device  status',
    deviceSetting: 'Device setting',
    deviceParamsDesc: 'Parameters describe',
    deviceNum: 'Device number (Online/Total)',
    firmwareUpgrade: 'Firmware update',
    snycUser:
        'DBS will push the personnel information to the device and overwrite the device data. Do you want to continue?',
    uploadUser:
        'The personnel information in the device will be uploaded to DBS. Do you want to continue?',
    hasNODevice: 'No equipment, no operation!',
    sn: 'SN',
    name: 'Device type',
    alias: 'Name',
    deviceList: 'List',
    deviceDetails: 'Device',
    deviceInfo: 'Device ',
    deviceConInfo: 'Network connection',
    deviceRunSysInfo: 'System information',
    addDevice: 'Add device',
    modifyDevice: 'Update device',
    snRequire: 'Please enter the sn',
    maxLength: 'The maximum length is 35',
    maxLength20: 'The maximum length is 20',
    devAlais: 'Please enter device name',
    assignDevice: 'Assign device',
    selectDeivces: 'Select device',
    selectUnBindDevice: 'Please select the unbind device',
    selectDept: 'Select the organization to bind to',
    unBindDept: 'Are you sure to unbind?',
    unBindBtn: 'Unbind',
    setEmployeeBind:
        'Are you sure the current employee is bound to the selected device?',
    deviceOperate: 'Device operation',
    confirmDeleteTip: 'Are you sure to delete this device?',
    deleteBioTemplate: 'Are you sure to delete the template?',
    deviceModel: 'Device model',
    deviceTimezone: 'Time zone',
    active: 'Active',
    connectionMode: 'Network mode',
    localIp: 'Intranet ip',
    macAddress: 'MAC address',
    remoteIp: 'Public network ip',
    ipLocation: 'Position',
    firmwave: 'Firmware version',
    commProtocol: 'Protocol',
    commProtocolVer: 'Protocol version',
    systemPlatform: 'Operating system',
    osVersion: 'OS version',
    storageSize: 'Storage size',
    storageFreeSize: 'Remaining memory',
    employeeCount: 'Employees',
    fpCount: 'Fingerprints',
    faceCount: 'Faces',
    fvCount: 'Near-infrared face',
    attlogCount: 'Attendance records',
    lastRequest: 'Last request time',
    status: 'Status',
    totalDevice: 'Total',
    online: 'Online',
    disbaleDevice: 'Disable',
    offLine: 'Offline',
    reboot: 'Are you sure to restart the device?',
    disabled: 'Are you sure to disable the device?',
    dataRange: 'Time range',
    uploadAttData: 'Upload attendance data',
    code: 'Attendance work code',
    Timezone: 'Device timezone',
    deviceStatus: 'Status',
    onlineStatus: 'Online',
    enableStatus: 'Enabled',
    equipmentStatus: 'Status',
    offLineTip: 'The device is offline. Operation is not allowed',
    enableTip: 'The device is disabled. Operation is not allowed',
    deviceEmploye: 'Employees',
    deviceHistoryLog: 'Log',
    deviceConfig: 'Parameter configuration',
    deviceParams: 'Parameters',
    deviceParamsValue: 'Value',
    noPermission: 'No permissions to add devices',
    deviceOptions: 'Parameters',
    version: 'Version',
    firmwaveSize: 'Size',
    description: 'Description',
    noInfo: 'There is no description',
    upgrade: 'Upgrade',
    retry: 'try again',
    upgradeFailed: 'Upgrade failed',
    beingUpgraded: 'Your device is being upgraded, please wait patiently',
    burningFirmware: 'The firmware is burning, please wait patiently',
    upgradeSuccessful: 'Upgrade successful!',
    downloadingFirmware:
        'Downloading firmware to your device, please wait patiently',
    deviceInternet:
        'Please make sure your device is powered up and connected to the Internet',
    sizeTip: 'unkown',
    memoryRemaining: 'Memory Remaining',
    storageRemaining: 'Storage Remaining',
    log: {
      userName: 'Operator',
      companyName: 'Company',
      requestParams: 'Parameters',
      createdDate: 'Operation time',
      methodType: 'Operation type'
    },
    biosignature: 'biosignature',
    devType: 'device Type',
    deviceCategory: 'device Category',
    dataOperation: 'Data operation',
    removeOldData: 'Do not clear old data',
    synInfo: 'Synchronization information',
    baseInfo: 'Basic personnel information',
    bioTemplateInfo: 'Personnel biological template',
    facePhotoInfo: 'Visible photo of personnel',
    synTip:
        'The synchronization information has been submitted. The system is executing. Please check it in the device later',
    synbtn: 'synchronization',
    updateAllDevice: 'Upgrade all devices',
    allCount: 'Total equipment',
    canUpgradeCount: 'Number of devices eligible for upgrade',
    noNeedUpgradeCount: 'No upgrade required',
    upgradingCount: 'Upgrading',
    updateConfirm: 'Are you sure you want to upgrade?',
    updateTip:
        'The upgrade command has been issued. Please check the upgrade history for details',
    updateText:
        'During equipment upgrade, please do not cut off the power and network. You can view the upgrade progress in the upgrade history',
    updateHistory: 'Upgrade history',
    upgrading: 'Upgrading',
    upgradeSuccess: 'Upgrade succeeded',
    upgradeError: 'Upgrade failed',
    downloading: 'Downloading',
    fire: 'Firing',
    upgradeTimeout: 'Upgrade timeout',
    updateDetails: 'Upgrade details',
    source: 'Operation source',
    lastVersion: 'Previous version',
    currentVersion: 'Target version',
    serviceUpdate: 'Server upgrade',
    clientUpdate: 'Device side upgrade',
    dbsUpdate: 'DBS upgrade'
  },
  license: {
    curLicense: 'Current license information',
    licenseStatus: 'State license',
    licentseValidity: 'Validity of license',
    deviceMax: 'Upper limit of devices',
    curDevice: 'Current number of devices',
    newsLicense: 'Latest online license application information',
    aduitStatus: 'Review the status',
    applyDevice: 'Number of Equipment requested',
    applyDate: 'Validity of application',
    remark: 'Note',
    approvalTime: 'Approval time',
    custormInfo: 'Customer information',
    custormNo: 'Client number',
    custormContact: 'Contact',
    custormPhone: 'Phone number',
    custormEmail: 'Email',
    custormCompany: 'Company',
    onlineLicense: 'Apply for permission online',
    offlineLicense: 'Offline application for Permission',
    importLicense: 'Import license',
    titles: 'Prompt',
    uploadTips1: 'Drag the file here, or',
    uploadTips2: 'Click on the upload',
    year: 'Year',
    save: 'Save',
    reset: 'Reset',
    noUpdate: 'Just skip it',
    tips:
        'Warm reminder: The pre-application information is only for reference during the audit, the specific data shall prevail.',
    updateTips:
        'Warm reminder: Copy this [license application code] to the license administrator to ask for the license file, and import it to complete the license upgrade.',
    deviceNum: 'Number of devices',
    apply: 'Validity',
    applyCode: 'Licence Application code',
    copy: 'Copy to clipboard with one key',
    inputContant: 'Please enter contact person',
    inputPhone: 'Please enter your mobile phone number',
    inputEmail: 'Please enter your email address',
    inputCompany: 'Please enter the company name',
    inputDevice: 'Please enter the number of devices',
    inputApply: 'Please enter expiry date',
    copySuc: 'Copied to clipboard',
    applySuc: 'Successful application'
  },
  statistics: {
    lastSevenDays: 'Last Seven Days',
    lastMonth: 'The Last Month',
    lastThreeMonths: 'The Last Three Months',
    more: 'more',
    apiSort: 'Interface call ranking',
    apiStatistics: 'Interface call statistics',
    todayCallsTotal: "Today's total",
    todayCallsSort: "Today's ranking",
    today: 'today',
    months: {
      month01: 'Jan',
      month02: 'Feb',
      month03: 'Mar',
      month04: 'Apr',
      month05: 'May',
      month06: 'Jun',
      month07: 'Jul',
      month08: 'Aug',
      month09: 'Sep',
      month10: 'Oct',
      month11: 'Nov',
      month12: 'Dec'
    },
    url: 'URI',
    apiName: 'API Name',
    callCount: 'Number of calls',
    interfaceCallCount: 'Interface Call Count',
    callDetail: 'Call details',
    appKey: 'AppKey',
    appName: 'APP Name',
    callTimes: 'Call {count} times',
    apiCallDetail: 'API Call Detail',
    appCallDetail: 'APP Call Detail',
    name: 'Name'
  },
  accManager: {
    doorName: 'Door name',
    devAlias: 'Belongs Device',
    devStatus: 'State',
    doorList: 'Door list',
    timeSlot: 'Access control period',
    permissionGroup: 'Access control permission group',
    timezoneName: 'Time period name',
    timeSlotDetails: 'Time period Details',
    holiday1: 'holiday1',
    holiday2: 'holiday1',
    holiday3: 'holiday1',
    groupName: 'Permission group name',
    timezone: 'Period of time',
    distributionDoor: 'Distribution Door',
    distributionPersonnel: 'Distribution Personnel',
    number: 'number',
    name: 'name',
    daterange: 'Date'
  },
  successOperation: {
    delete: 'Deletion succeeded',
    add: 'Successfully added',
    sendCode: 'Verification code has been sent',
    sendEmail: 'Email successfully sent',
    reset: 'Reset the AppSecret success',
    update: 'Update successfully',
    cancellationSuccess: 'Cancellation of success'
  },
  errorOperation: {},
  warningOperation: {
    hasPhoneOrEmail:
        'You do not bind your mobile phone or email, please bind first'
  },
  operation: {
    addNew: 'Add ',
    save: 'Save',
    confirm: 'Confirm',
    saving: 'Saving...',
    checkAll: 'Check All',
    search: 'Search',
    freeze: 'Freeze',
    unfreeze: 'Unfreeze'
  },
  attendanceRecord: {
    exportRecord: 'Export',
    device: 'Device',
    employee: 'Employee',
    pin: 'Employee no',
    sn: 'SN',
    deviceName: 'Name',
    to: 'to',
    checktime: 'Punch time',
    workcode: 'Attendance work code',
    dataRange: 'Date',
    commitTime: 'Commit time',
    punchTime: 'Punch time',
    lastweek: 'Last week',
    lastmonth: 'Last month',
    lastThreeMonths: 'Last three months',
    exportResult: 'Export search results',
    exportAll: 'Export all',
    verifyPhoto: 'Verify Photo',
    view: 'View'
  },
  witnessRecord: {
    checkRecord: 'Check record',
    personRecord: 'Witness record',
    checkFail: 'Check failure',
    checkSuccess: 'Check success',
    bornPerson: 'Prohibited personnel',
    checkTime: 'Check time',
    checkResult: 'Check results',
    employeeNo: 'Personnel numbers',
    normalTemperature: 'Normal temperature',
    abnormalTemperature: 'Abnormal temperature',
    deviceSn: 'Sn',
    temperature: 'Temperature',
    hasMask: 'Has mask',
    yes: 'Confirm',
    no: 'Cancel',
    checkMode: 'Verify way',
    name: 'name',
    beginEndTime: 'Starting time',
    accEvent: 'Access  event',
    operatorPerson: 'Operator',
    normalEvent: 'Normal event',
    warnEvent: 'Warning events',
    abnormalEvent: 'Abnormal events',
    doorNum: 'Door number',
    time: 'Time',
    outInStatus: 'In or out',
    doorEvent: 'Access event'
  },
  verifyintModel: {
    '0':
        'Finger vein / face / fingerprint / card / password (automatic identification)',
    '1': 'Only fingerprint',
    '2': 'User ID verification ',
    '3': 'Only password ',
    '4': 'Only card ',
    '5': 'Fingerprint or password ',
    '6': 'Fingerprint or card ',
    '7': 'Card or password ',
    '8': 'User ID + fingerprint ',
    '9': 'Fingerprint + password ',
    '10': ' Card + fingerprint ',
    '11': ' Card + password ',
    '12': ' Fingerprint + password + card ',
    '13': ' User ID + fingerprint + password ',
    '14': ' User ID + fingerprint or Card + fingerprint ',
    '15': ' Face ',
    '16': ' Face + fingerprint ',
    '17': ' Face + password ',
    '18': ' Face + card ',
    '19': ' Face + fingerprint + card ',
    '20': ' Face + fingerprint + password ',
    '21': ' Finger vein',
    '22': ' Finger vein + password',
    '23': ' Finger vein + card ',
    '24': ' Finger vein + password + card ',
    '25': ' Palm print ',
    '26': ' Palm print + card',
    '27': ' Palm print + face',
    '28': ' Palm print + fingerprint ',
    '29': ' Palm print + fingerprint + face ',
    '30': 'Only  Id card',
    '31': 'Id card +face',
    '32': 'Id card +face +trusted',
    '33': 'Id card +fingerprint +face',
    '34': 'Trusted only authentication',
    '200': ' Other',
    BioDataCount: 'Face template(visible light)',
    FingerCount: 'Fingerprint',
    FaceCount: 'Face template(near-infrarared)'
  },
  company: {
    apiUserTips:
        'Must be passed when using the API as a unique identifier of the calling interface',
    loginUserTips:
        'When using API must pass parameters, verify the legitimacy of the enterprise account',
    entryCompany: 'Enter company',
    selectCountry: 'Please select the country first',
    updateInfo: 'Update company information',
    devList: 'Device list',
    cmpInfo: 'Company information',
    logo: 'logo',
    dataFormat: 'Date format',
    timeFormate: 'Time format',
    language: 'Language',
    state: 'Province',
    country: 'Country',
    zipCode: 'Postcode',
    city: 'City',
    email: 'Email',
    phone: 'Telephone',
    address: 'Address',
    active: 'Active status',
    agentCode: 'Agent code',
    integrator: 'Integrator',
    enable: 'Available or not',
    webSite: 'Website',
    name: 'Name',
    code: 'Company code',
    type: 'Type',
    accountInfo: 'Basic',
    companyContactInfo: 'Contact',
    Contact: 'Contact',
    preference: 'Pre-setting',
    address1: 'Street 1',
    address2: 'Street 2',
    address3: 'Street 3',
    status: 'Status',
    Integrator: 'Integrator',
    industry: 'Industry involved',
    createdDate: 'Created time',
    modifiedDate: 'Modified time',
    employeeList: 'Employee list',
    assEquipment: 'Associated equipment',
    accAuthority: 'Access control authority'
  },
  tenant: {
    companyList: 'Company list',
    companyDetail: 'Company details',
    settings: 'Basic',
    accountUser: 'Account management',
    configurations: 'Parameter',
    owner: 'Company name',
    parameterName: 'Name',
    parameterValue: 'Value',
    dataConstraint: 'Description',
    confirmRestoreTip: 'Are you sure restore to default?',
    confirmRestore: 'Confirm restore',
    cancelRestore: 'Cancel restore',
    adminAccount: 'Administrator',
    integrationAccount: 'Integration account',
    device: 'Device'
  },
  sysOption: {
    uploadFail: 'Failed to upload. Please upload a file in html format and utf-8 encoding format',
    selectLang: 'Please select a language',
    download: 'download',
    inputFile: 'Please select a file',
    selectFile: 'Select File',
    verLang: 'Select Language',
    inputVer: 'Please enter the version number information',
    version: 'Version No',
    uploadFile: 'Upload files',
    createTime: 'Creation time',
    fileName: 'file name',
    agreeManager: 'Privacy Agreement Management',
    deleteParams: 'Do you want to delete this event type?',
    updateDeviceParams: 'Update equipment parameters',
    addDeviceParams: 'New Equipment Parameters',
    dictionaryType: 'Dictionary Type',
    paramsValueType: 'Parameter Value Type',
    isAllowModify: 'Allow modification?',
    onlyRead: 'read-only',
    readAndWrite: 'Reading and writing',
    protocol: 'Communication protocol',
    inputDictionary: 'Please enter the data dictionary type',
    dictionary: 'Dictionary Type',
    paramsValue: 'Parameter Value Type',
    inputConnection: 'Please enter the associated parameters',
    connect: 'Associated parameters',
    selectWay: 'Please select a method',
    isAllow: 'Allow modification?',
    inputReadWay: 'Please select the read/write mode',
    readWay: 'Read/write status',
    inputSaveParam: 'Please enter the storage name',
    saveParam: 'Storage name',
    inputOriginalParams: 'Please enter the original parameters',
    originalParam: 'Original parameters',
    searchProtocol: 'Please select a communication protocol',
    deleteEvent: 'Do you want to delete this event type?',
    updateAccEventType: 'Update access control event type',
    addAccEventType: 'New access control event type',
    desc: 'describe',
    inputDescValue: 'Please enter a description',
    inputDescName: 'Please enter a description name',
    eventDesc: 'Event Description',
    inputStandardType: 'Please enter the standard event type',
    standardType: 'Standard Event Type',
    inputOriginalType: 'Please enter the original event type',
    originalType: 'Original event type',
    eventType: 'Please select an event type',
    accEventType: 'Type of access control event',
    deviceParamsType: 'Equipment parameter management',
    not: 'Cancel',
    desPla: 'Please enter description',
    plainPla: 'Please enter a value',
    namePla: 'Please enter name',
    yes: 'yes',
    no: 'no',
    readonly: 'Read only',
    enable: 'Enable',
    code: 'Name',
    plainVal: 'Value',
    tocompany: 'Sync',
    des: 'Description',
    add: 'Add system parameters',
    update: 'Update system parameters',
    requireCode: 'Please enter the parameter name',
    requirePlainVal: 'Please enter parameter values'
  },
  pushlog: {
    dataType: 'data type',
    pushResult: 'Push results',
    success: 'success',
    fail: 'fail',
    pushTime: 'Push time',
    pushDetails: 'Push log details'
  },
  cancelAccount: {
    cancelAccount: 'Destroy Account',
    agreements: 'Agreements and regulations',
    view: 'View',
    developer: 'Developer Service Agreement',
    privacyPolicy: 'privacy policy',
    dataProcess: 'Data Processing Agreement',
    withdrawal: 'Withdraw consent',
    cancelTip:
        'This operation will log out your account. After you log out, you will not be able to log in again. Smart DBS will also clear all data related to your account. Please proceed with caution.',
    exportTip:
        'You are about to log out of this account. After you log out, the platform will no longer store and destroy your stored data. ',
    clickHere: 'Click Here',
    verificationType: 'Verification method',
    changeType: 'Change',
    code: 'Code',
    inputCode: 'Please enter the verification code',
    withdraw: 'withdraw',
    click: 'GET',
    protocol: 'Protocol'
  },
  exportData: {
    recordData: 'record Data',
    tip: 'Only available in recent one month',
    infoData: 'information data',
    export: 'Export',
    exportTip:
        'The data you checked will be sent to the specified mailbox. Please enter the mailbox that can receive mail normally below.',
    inputEmail: 'Please enter your email address',
    emainValidate: 'Please enter the correct email address',
    sendEmailTip:
        'The backend is processing data asynchronously. Please check the mail later',
    attendanceRecord: 'Attendance Record',
    verificationRecord: 'Verification Record',
    witnessRecord: 'Witness Record',
    companyInformation: 'Company Information',
    organizationalStructure: 'Organizational Structure'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/en/en.js